import { flow, toGenerator, types } from 'mobx-state-tree'

import { FetchModel } from '../models/FetchModel'
import { BackendVersionSnapshot, ReleaseInfoModel } from '../models/Navbar/ReleaseInfoModel'
import { OperationFailure, OperationInProgress, OperationNotStarted, OperationStatusModel, OperationSuccess } from '../models/common/OperationStatus'
import { WebSocketConnection } from '../utils/WebSocketConnection'
import { CenterOpenState } from '../models/Navbar/CenterOpenState'

interface CenterStateTransition {
  open_state: CenterOpenState
}

export const NavbarStore = FetchModel
  .named('NavBarStore')
  .props({
    releaseInfo: types.maybeNull(ReleaseInfoModel),

    centerStatus: types.maybeNull(types.enumeration('CenterOpenState', Object.values(CenterOpenState))),

    fetchStatus: types.optional(OperationStatusModel, () => OperationNotStarted())
  })
  .views((self) => ({
    get backendVersionUrl(): string {
      return `${self.baseUrl}version/`
    },
  }))
  .actions((self) => ({
    _updateCenterStatus(centerStatusUpdate: CenterStateTransition) {
      self.centerStatus = centerStatusUpdate.open_state
    },
    onWebsocketDisconnected() {
      self.centerStatus = null
    },
  }))
  .actions((self) => ({
    _fetchAndSetReleaseInfo: flow(function* fetchAndSetReleaseInfo() {
      self.fetchStatus = OperationInProgress()

      const loadBackendVersionsResult = yield* toGenerator(
        self.loadObjectOrError<BackendVersionSnapshot>(
          self.backendVersionUrl,
          {},
          { fetchOperationName: 'Fetch backend release info' },
        ),
      )

      if (loadBackendVersionsResult.error) {
        self.fetchStatus = OperationFailure(loadBackendVersionsResult.error)
        return
      } 
      self.releaseInfo = ReleaseInfoModel.create(loadBackendVersionsResult.result)

      self.fetchStatus = OperationSuccess()
    }),
    _subscribeToCenterStatusUpdates() {
      // TODO: take care of error if this returns error
      void WebSocketConnection.subscribeToSubject('center_open_state', self._updateCenterStatus)
      WebSocketConnection.subscribeToWebsocketDisconnect(self.onWebsocketDisconnected)
    }
  }))
  .actions((self) => ({
    initializeNavbar() {
      void self._fetchAndSetReleaseInfo()
      self._subscribeToCenterStatusUpdates()
    }
  }))
